import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { LoadingController } from "ionic-angular";
import domtoimage from 'dom-to-image';

@Injectable()
export class PrintService {
  constructor(public loadingCtrl: LoadingController) {}

    print(componentName) {
      var node = document.getElementById(componentName);

      domtoimage.toPng(node)
      .then(function (dataUrl) {
          var popup=window.open();
            popup.document.write('<img src=' + dataUrl + '>');
            popup.document.close();
            popup.focus();
            popup.print();
            popup.close();
      })
      .catch(function (error) {
          console.error('oops, something went wrong!', error);
      });
    }
}



// WEBPACK FOOTER //
// ./src/services/printService.ts